
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import BlogNewsletter from './components/BlogNewsletter';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function BlogPage() {
  useSEO({
    title: 'Daliah Secret Blog | Luxury Perfume & Hair Care Tips',
    description: 'Explore expert guides on luxury perfumes, natural hair care routines, fragrance layering tips, and sustainable beauty practices. Daliah Secret blog delivers beauty insights from master perfumers and hair care specialists.',
    keywords: 'perfume tips, hair care guide, fragrance layering, natural beauty, oud perfumery, argan oil hair',
    canonical: '/blog',
    ogType: 'blog',
    schema: generateWebPageSchema(
      'Daliah Secret Blog',
      'Expert beauty and fragrance insights from Daliah Secret specialists',
      '/blog'
    ),
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <BlogHero />
        <BlogGrid />
        <BlogNewsletter />
      </main>
      <Footer />
    </div>
  );
}
